export function parseChangeRequestDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const changeRequestIdRaw = params.get('changeRequestId') || params.get('id');
  const changeRequestId = changeRequestIdRaw ? Number(changeRequestIdRaw) : null;

  if (!(Number.isFinite(changeRequestId) && changeRequestId > 0)) {
    return null;
  }

  return { changeRequestId };
}
